<template>
    <div class="post-comment">
        <button-header left-title="취소" title="답글" right-title="등록" v-on:leftClickEvent="closePopup" v-on:rightClickEvent="registReply" />

        <div class="comment-block">
            <div class="left">
                <img v-if="comment.profile_image_url != null" :src="comment.profile_image_url" width="30" height="30" />
                <img v-else src="https://ba8hb5guu4.ecn.cdn.ofs.kr/base/image/common/avata.png" width="30" height="30" />
            </div>
            <div class="right">
                <div class="title">
                    <div>{{ comment.member_name }} <span>{{ comment.comment_regist_date | convertDateYYYYMMDD }}</span></div>
                </div>
                <div class="comment">
                    {{ comment.comment }}
                </div>
                <div class="footer">
                    <best interest-div="31" :related-no="comment.comment_no" />
                </div>
            </div>
        </div>

        <div class="reply-block">
            <textarea class="no-outline" placeholder="답글을 입력해 주세요." rows="10" v-model="reply"></textarea>
        </div>
    </div>
</template>

<script>
    import * as ajax from "../../utils/ajax";
    import * as utils from "../../utils/utils";
    import * as alert from '../../utils/alert';
    import ButtonHeader from "../header/ButtonHeader";
    import Best from "../interest/best";

    export default {
    name: 'ReplyComment',
        components: {Best, ButtonHeader},
        props: {
            commentNo: Number
        },
    data() {
        return {
            reply: "",
            comment: {
                "comment": "",
                "comment_no": 0,
                "best_comment": 0,
                "member_name": "",
                "profile_image_url": "",
                "comment_regist_date": "",
                "reply_no": 0
            }
        }
    },
    methods: {
        closePopup() {
            this.$emit("hideReplyComment");
        },
        registReply() {
            const params = {
                comment_no: this.commentNo,
                comment: this.reply
            };
            ajax.Post(this, "/api/board/comment/", params, function(ref, data) {
                alert.alert("답글이 등록 되었습니다.", "확인");
                ref.$emit("hideReplyComment");
                ref.reply = "";
            });
        }
    },
    computed: {
    },
    watch: {
        'commentNo': function(val, oldVal) {
            ajax.Get(this, "/api/board/comment/" + val, function(ref, data) {
                ref.comment = data;
            });
            this.reply = ""
        }
    },
    filters: {
        // Filter definitions
        minuteToStringFormat(value) {
            return utils.minuteToStringFormat(value);
        },
        thousandSeparator(value) {
            return utils.thousandSeparator(value);
        },
        convertDateYYYYMMDD(value) {
            return utils.convertDateYYYYMMDD(value);
        }
    }
}
</script>

<style scoped lang="scss">
    div.post-comment {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: $seventh-color;
        z-index: 200;
    }

    div.top-section {
        padding: 20px 18px 10px 18px;
        border-bottom: 1px solid $line-primary-color;
        background-color: white;

        display: flex;
        align-items: center;
        justify-content: space-between;

        div.cancel-button {
            margin-right: 3px;
            width: 41px;
            height: 22px;
            border: 1px solid #d4d4d4;
            border-radius: 22px;
            text-align: center;
            font-size: $font-base12;
            font-weight: 400;
            color: #7b7b7b;
        }
        div.title {
            font-weight: 600;
            color: black;
        }
        div.post-button {
            margin-right: 3px;
            width: 41px;
            height: 22px;
            border: 1px solid #fe7200;
            border-radius: 22px;
            text-align: center;
            font-size: 11px;
            font-weight: 400;
            color: #fe7200;
        }
    }

    div.comment-block {
        margin: 32px 24px 0px 24px;
        padding-bottom: 18px;
        border-bottom: 1px solid $line-secondary-color;

        display: flex;
        justify-content: space-between;

        font-size: $font-base14;

        div.left {
            width: 40px;
            margin: 0 5px 0 0;
            img {
                border-radius: 50%;
            }
        }
        div.right {
            flex: 1;
            div.title {
                display: flex;
                justify-content: space-between;

                span {
                    margin: 0 0 0 10px;
                    font-size: $font-base12;
                    color: $font-fourth-color;
                }
                ion-button {
                    width: 40px;
                    height: 15px;
                }
            }
            div.footer {
                margin-top: 5px;

                display: flex;
                align-items: center;

                div.like {
                    margin: 0 10px 0 5px;
                    color: $font-third-color;
                }
            }
        }
    }

    div.reply-block {
        margin: 20px 24px;
        textarea {
            width: 100%;
            background-color: $seventh-color;
        }
    }
</style>
